module.exports = require('./lib/core/core');


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/core.js
// module id = 910
// module chunks = 0